import { Button, Form, Modal, message } from "antd";
import _ from "lodash";
import React, { useState } from "react";
import {
  useGetAllCustomersQuery,
  useUpdateCustomerMutation,
} from "../../generated/types";
import { CustomerEditor } from "./CustomerEditor";
import { Project } from "./ProjectsTableContainer";

const EDIT_CUSTOMER_TXT = "Edit Customer";

type Props = {
  projects: Project[];
};

export const EditCustomerButton = (props: Props) => {
  const { projects } = props;
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [form] = Form.useForm();
  const [selectedCustomer, setSelectedCustomer] = React.useState<string | null>(
    null,
  );

  const { refetch } = useGetAllCustomersQuery();

  const [updateCustomer] = useUpdateCustomerMutation({
    onCompleted: () => {
      message.success("Customer updated successfully!");
      form.resetFields();
      setModalVisible(false);
      refetch();
    },
    onError: (error) => {
      message.error(`Failed to update customer: ${error.message}`);
    },
  });

  const handleOk = async () => {
    try {
      setIsSubmitting(true);
      await form.validateFields();

      const values = form.getFieldsValue();
      const customer = values.selectedCustomer;

      if (!customer) {
        message.error("Please select a customer first");
        return;
      }

      await updateCustomer({
        variables: {
          input: {
            customer: customer,
            name: values.name || null,
            collabStarted: values.collabStarted
              ? values.collabStarted.format("YYYY-MM-DD")
              : null,
            imagesCaptured: values.imagesCaptured || null,
            upcomingProjects: values.upcomingProjects
              ? parseInt(values.upcomingProjects, 10)
              : 0,
          },
        },
      });
    } catch (error) {
      console.error("Update customer error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleModalOpen = () => {
    form.resetFields();
    setSelectedCustomer(null);
    setModalVisible(true);
  };

  const customers = _(projects)
    .map((p) => p.customer)
    .uniq()
    .value();

  return (
    <>
      <Button type="primary" onClick={handleModalOpen}>
        {EDIT_CUSTOMER_TXT}
      </Button>
      <Modal
        visible={modalVisible}
        title={EDIT_CUSTOMER_TXT}
        onCancel={handleCancel}
        onOk={handleOk}
        confirmLoading={isSubmitting}
        okText={"Update"}
      >
        <>
          <CustomerEditor
            customers={customers}
            projects={projects}
            form={form}
            setSelectedCustomer={setSelectedCustomer}
            selectedCustomer={selectedCustomer}
          />
        </>
      </Modal>
    </>
  );
};
